import { useState,useContext } from 'react';

import './SmartCardLogin.scss';
import DetailsMain from '../../../General/Details/DetailsMain';
import SmartCardInstall from './Install/SmartCardInstall';
import { Container, Row, Col } from 'react-bootstrap';
import Header from '../../../General/Static/Header';
import arrowRightBlue from '../../../../assets/icons/arrow-right-blue.svg';
import ladyArt from '../../../../assets/img/wizard_bg.svg';
import guyWithLaptop from '../../../../assets/img/biometric_bg.png';
import moviePlayer from '../../../../assets/icons/movie-player.svg';
import LoginContext from '../../../../store/login-context';


declare function Translate(key: string): string;
declare var _curLang: any;
declare var _loginType: any;
declare var _loginTypeLoa4Landing: any;
declare var _loginTypePkiTamuz: any;
declare var _loginTypeSMSOTP: any;

const SmartCardLogin = props =>{

  const ctx = useContext(LoginContext);

  const [installProcess,setInstallProcess] = useState(true);
  const [neededInfo, setNeededInfo] = useState<string[]>([]);
  const [isDetailsCompleted, setIsDetailsCompleted] = useState(false);  

  const update = () => {
    props.forceUpdate();
  };

  const onInstalledProccessFinished = (neededInfo: any) => {
    setInstallProcess(false);
    setNeededInfo(neededInfo); 
    if(neededInfo.length === 1 && neededInfo[0] === ''){
      onDetailsCompleted();
    }   
  };

  const onDetailsCompleted = () => {
    // setIsDetailsCompleted(true);    
    localStorage.setItem('preferredLoginType', _loginTypePkiTamuz ); 
    ctx.setSuccess();
  };

  const goToOldProcess = () => {
    _loginType = _loginTypeSMSOTP;
    ctx.toggleCard();  
    ctx.scSelected();  
  };

  const onKeyOldProcess = (event) => {
    if (event.charCode === 13){
      goToOldProcess();
    }
  };

  return (
    <Container fluid className='px-0'>
      <Header
        showLogo={true}
        forceUpdate={update}
        isBiometricHeader={true}
      />
      <Row className='left-side'>
        <Col
          className='side-bg ps-0 pe-0'
          xl={5}
          lg={12}
          md={12}
          sm={12}
          xs={12}
        >
          <div 
               className={
                installProcess ? 'install-process-container' : 'main-top-container'
              }   
          >
            <div
              className='side-upper' 
              style={isDetailsCompleted ? { display: 'none' } : {}}               
            >              
              {installProcess ? (
                <div className='title-container'>
                  <Col xl={8} lg={8} md={8} sm={12} xs={12}>
                    <div className='d-flex align-items-center mt-3'>
                      <img src={arrowRightBlue} aria-hidden="true" />&nbsp;&nbsp;                        
                      <a className='bIdLoginAnchor' href={document.referrer}>
                        {Translate('N_Login_Bio_ID_button')}
                      </a>                                                
                    </div>
                    <div className='side-title mb-2' role="heading" aria-level={2}>
                      {Translate('N_Login_SmartCard_title')}
                    </div>
                    <div className='side-text'>
                      {Translate('N_Login_SmartCard_info')}
                    </div>                      
                    <div className="d-flex flex-row justify-content-start align-items-center mt-2 smart-card-movie" aria-hidden="true">
                      <img src={moviePlayer} width="20px" height="14px"/>&nbsp;&nbsp;
                      <a href='https://youtu.be/uwQPK-G7VC8' target='_blank' rel="noopener noreferrer" className='regular'>                
                        {Translate('N_General_watch_tutorial')}
                      </a> 
                    </div> 

                  </Col>
                </div>
              ) : (
                <Row
                  className={
                    _curLang === 'en' || _curLang === 'ru'
                      ? 'justify-content-start'
                      : 'justify-content-end'
                  }
                >
                    <Col
                      xl={_curLang === 'en' || _curLang === 'ru' ? 12 : 5}
                      lg={12}
                      md={12}
                      sm={12}
                      xs={12}
                    >
                      <div className='side-title mb-2' role="heading" aria-level={2}>
                        {Translate('N_Login_Bio_ID_registration-title')}
                      </div>
                      <div className='side-text'>
                        {Translate('N_Login_Bio_ID_registration-subtitle')}
                      </div>
                      <div className='side-text'>
                        {Translate('N_Login_Bio_ID_registration-subtitle_1')}
                      </div>
                    </Col>
                </Row>
              )}
            </div>
            <div>
                <img
                  src={installProcess ? guyWithLaptop : ladyArt}
                  aria-hidden="true"
                  className={
                    installProcess ? 'guyWithLaptop' : 'ladyArt'
                  }            
                />
              <div className='d-flex align-items-center justify-content-center mt-2'>
                <div className='old-sc-version'>{Translate('N_Login_smart_card_problem')} </div>
                <div 
                  id='toOldVersionLink'
                  className='old-sc-version-link'
                  tabIndex={0}
                  onClick={goToOldProcess}
                  onKeyPress={onKeyOldProcess}
                  role="link"
                >
                    <span>{Translate('N_Login_smart_card_back_old_version')}</span>                                   
                </div> 
              </div> 
            </div>
          </div>
        </Col>

        <Col
          xl={7}
          lg={12}
          md={12}
          sm={12}
          xs={12}
          className='left-container'
        >
          {installProcess ? (
            <SmartCardInstall              
              onProcessFinished={(neededInfo) =>
                onInstalledProccessFinished(neededInfo)
              }
              goToOldVersion={props.goToOldVersion}
            />
          ) : neededInfo.length > 0  && neededInfo[0] !== '' &&
            <DetailsMain              
              neededInfo={neededInfo}
              detailsCompleted={onDetailsCompleted}
            />
          }
        </Col>
      </Row>
    </Container>
  );

};
export default SmartCardLogin;

